<template>
  <div>
    <v-dialog v-model="addDialog" width="400">
      <Manage
        :key="dialogKey"
        :checklistItem="checklistItem"
        @close="addDialog = false"
        @confirm="list(), (addDialog = false)"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t(
                `Tem certeza de que deseja excluir este item padrão de Checklist?`
              )
            }}
          </div>

          <v-btn class="ma-1" color="grey" text @click="deleteDialog = false">
            Cancelar
          </v-btn>

          <v-btn
            class="ma-1"
            color="error"
            text
            @click="remove"
            :loading="loading"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <div class="d-flex justify-end mr-2 mt-2">
      <v-btn
        class="primary-button mr-3"
        depressed
        @click="
          ;(dialogKey = !dialogKey), (checklistItem = {}), (addDialog = true)
        "
      >
        {{ $t('Novo item') }}
      </v-btn>
      <v-btn class="secondary-button" depressed @click="show = !show">
        {{ show ? $t('Fechar') : $t('Filtros') }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-show="show" class="px-4 mb-6">
        <v-form ref="form">
          <v-row class="ma-0" align="center">
            <v-col>
              <span class="text ml-1">{{ $t(`Nome`) }}</span>
              <v-text-field
                class="primary-input"
                :placeholder="$t('Pesquisar')"
                v-model="filter.name"
                outlined
                hide-details="auto"
                @keyup.enter="applyFilter"
              >
              </v-text-field>
            </v-col>

            <v-col>
              <span class="text ml-1">{{ $t('Classe de Checklist') }}</span>
              <v-autocomplete
                :loading="classLoading"
                :items="classes"
                item-text="name"
                item-value="id"
                v-model="filter.classId"
                append-icon="mdi-chevron-down"
                class="primary-input"
                :placeholder="$t('Pesquisar por nome')"
                outlined
                hide-details="auto"
                @keyup.enter="applyFilter"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <div class="d-flex justify-end">
            <v-btn class="clear-button mr-1" depressed @click="reset">
              {{ $t('Limpar') }}
            </v-btn>
            <v-btn @click="applyFilter" class="secondary-button" depressed>
              {{ $t('Aplicar filtros') }}
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="filter.pageSize"
      class="main-table"
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhum item encontrado')"
      hide-default-footer
      hide-default-header
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.createdAt`]="{ item }">
        <span> {{ formatDate(item.createdAt) }} </span>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              small
              depressed
              @click="
                ;(dialogKey = !dialogKey),
                  (checklistItem = item),
                  (addDialog = true)
              "
              v-on="on"
            >
              <v-icon size="22">mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#921616"
              depressed
              small
              @click=";(checklistItem = item), (deleteDialog = true)"
              v-on="on"
            >
              <v-icon size="22">mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="filter.pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="items.length">
          <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
          <br />
          <!-- <span>
            Selecionados:
            {{ items.length }}
          </span> -->
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import FormatDate from '../../../../../Utils/FormatDate'
import Manage from './manage.vue'

export default {
  name: 'StandardChecklistItemPage',

  components: {
    Manage,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getChecklisItemClasses()
    this.list()
  },

  data() {
    return {
      loading: false,
      checklistItem: {},
      addDialog: false,
      dialogKey: false,
      deleteDialog: false,
      apiService: new ApiService(),
      show: false,
      filter: {
        page: 1,
        pageSize: 10,
      },
      classLoading: false,
      classes: [],
      items: [],
      sizes: [10, 30, 90, 180],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Item',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Classe',
          align: 'center',
          value: 'checklistItemClass.name',
        },
        {
          text: 'Data de criação',
          align: 'center',
          value: 'createdAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
    }
  },

  watch: {
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },

  methods: {
    async remove() {
      this.loading = true
      await this.apiService
        .delete(`standardChecklistItem/${this.checklistItem.id}`)
        .then(() => {
          this.list()
          this.deleteDialog = false
          this.loading = false
        })
        .catch(() => {
          this.loading = true
        })
    },

    async getChecklisItemClasses() {
      this.classLoading = true

      await this.apiService
        .get(`checklistItemClass/list/${this.institutionId}`)
        .then((response) => {
          this.classes = response.content
          this.classLoading = false
        })
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    applyFilter() {
      this.list()
    },

    reset() {
      this.filter.page = 1
      this.filter.name = ''
      this.filter.classId = ''
      this.list()
    },

    list() {
      this.apiService
        .post('standardChecklistItem/list/paginate', this.filter)
        .then((response) => {
          this.items = response.content.entities

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
    },
  },
}
</script>

<style scoped lang="scss">
.table-custom {
  &::v-deep .v-data-table__wrapper {
    thead {
      border: none !important;

      th {
        border: none !important;
        &:first-child {
          border-radius: 4px 0 0 4px;
        }

        &:last-child {
          border-radius: 0 4px 4px 0;
        }
      }
    }
  }
}
.pagination {
  margin: 1.5rem 0;
  background: $grey-1;
  border-radius: 4px;
  padding: 0.8rem 1.3rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .item-pagination {
    flex: 1 1 100px;
    margin: 0.5rem 0;
    .btn {
      border-radius: 4px;
      background: #c7c9ca;
      font-weight: bold;
    }
    .registros {
      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        color: $grey-2;
      }
    }
  }
  .block-one {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .block-two {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .pagination-item {
      &::v-deep .v-pagination {
        li {
          button {
            box-shadow: none !important;
            background: none !important;
            color: $grey-2;
            font-weight: 500;
          }

          .v-pagination__item--active {
            color: $black-1;
          }
        }
      }
    }
  }

  @media (max-width: 406px) {
    .block-one {
      justify-content: center;
    }
    .block-two {
      justify-content: center;
    }
  }
}
</style>
